exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-cart{border-radius:100%!important;width:36px!important;background:#fff!important;border:2px solid #01ad83!important;color:#01ad83!important;display:flex!important;justify-content:center!important;align-items:center!important;font-size:20px!important}", ""]);

// exports
